import React, { useState } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

import useTimeline from '../../timeline/useTimeline';
import { getDateForApi } from '../../../../utils/dates';
import { editTreatmentInstanceNotes } from '../../../../actions/areas/planner';
import { selectionTypes } from '../../../../enums/treatmentSelectionType';
import globals from '../../../../globals/communityGlobals';

export default function ChangeTreatmentNotes({ treatmentDetails, toggleRefresh, includeTreatments }) {
  const [notes, setNotes] = useState(treatmentDetails.treatmentInstance.notes);
  const notesMaxLength = 1000;
  const errorsLocale = globals.getArea('error');

  const {
    getFlag,
    setFlag,
    refreshClinicianTreatmentsAndClosePanels,
    setActiveAssignment,
    getAccessToken,
  } = useTimeline();

  const selectionType = () => {
    if (treatmentDetails.treatment.isSpecific) return selectionTypes.specific;
    if (treatmentDetails.treatment.isMultiple) return selectionTypes.multiple;
    return selectionTypes.timeSlot;
  };

  const addTreatmentInstanceNotes = () => {
    const treatmentInstance = treatmentDetails.treatmentInstance;
    let model;
    if (selectionType() === selectionTypes.specific) {
      model = {
        treatmentId: treatmentInstance.treatmentId,
        treatmentInstanceId: treatmentInstance.treatmentInstanceId,
        isSpecific: true,
        occurenceOriginalDate: getDateForApi(treatmentInstance.occurrence),
        specificTimeFrom: getDateForApi(treatmentInstance.effectiveTimeSlots[0].from),
      };
    } else {
      model = {
        treatmentId: treatmentInstance.treatmentId,
        treatmentInstanceId: treatmentInstance.treatmentInstanceId,
        isSpecific: false,
        occurenceOriginalDate: getDateForApi(treatmentInstance.occurrence),
        timeSlotsMatrix: treatmentInstance.selectedTimeSlots,
        timeSlotPackageId: treatmentInstance.timeSlotPackage.id,
      };
    }
    model.notes = notes;

    editTreatmentInstanceNotes(getAccessToken, model, () => {
      refreshClinicianTreatmentsAndClosePanels();
      setActiveAssignment(null);
      if (includeTreatments) toggleRefresh();
    });
  };

  const notesValidation = () => {
    return notes && notes.length > notesMaxLength;
  };

  const headerInfo = () => {
    return (
      <div className="grey-sidePanel-header">
        <div className="sidePanel-header-subtitle">
          <Box flexGrow={1} py={1}>
            <Typography variant="subtitle1">Add Notes</Typography>
          </Box>
        </div>
      </div>
    );
  };

  const mainContent = () => {
    return (
      <div className="reschedule-sidePanel-form">
        <Box mt={2}>
          <Typography variant="h6" gutterBottom>
            {`Notes`}
          </Typography>
          <TextField
            required
            multiline
            style={{ width: '100%' }}
            value={notes}
            error={notesValidation()}
            helperText={errorsLocale.getMsg('validationMaxLength', [`${notesMaxLength}`])}
            onChange={e => setNotes(e.target.value)}
          />
        </Box>
      </div>
    );
  };

  const actionButtons = () => {
    return (
      <div className="sidePanel-footer">
        <div className="sidePanel-buttons">
          <div className="sidePanel-BackButton">
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                setFlag('showTreatmentNotesSidePanel', false);
              }}
            >
              Back
            </Button>
          </div>
          <div className="sidePanel-saveButton">
            <Button
              variant="contained"
              color="primary"
              disabled={notesValidation()}
              onClick={addTreatmentInstanceNotes}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer
        anchor="right"
        open={getFlag('showTreatmentNotesSidePanel') === true}
        onOpen={() => {}}
        onClose={() => setFlag('showTreatmentNotesSidePanel', false)}
        id="note"
      >
        <div className="sidePanel-wrapper" style={{ width: '350px' }} id="add-noted-side-panel">
          {headerInfo()}
          {mainContent()}
          {actionButtons()}
        </div>
      </SwipeableDrawer>
    </section>
  );
}
